import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';

const CancelPage = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-gray-50 py-32">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl mx-auto px-6 text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
        >
          <XCircle className="w-24 h-24 text-destructive mx-auto mb-6" data-testid="cancel-icon" />
        </motion.div>
        <h1 className="font-heading text-5xl md:text-6xl text-primary uppercase tracking-tight mb-6" data-testid="cancel-title">
          {t('cancel.title')}
        </h1>
        <p className="text-xl text-gray-700 mb-8 leading-relaxed">
          {t('cancel.message')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to={`/${i18n.language}/donate`}
            data-testid="try-again-button"
            className="inline-block bg-accent text-primary font-bold uppercase tracking-widest px-12 py-5 text-lg hover:bg-primary hover:text-white transition-all duration-300 clip-path-slant"
          >
            {t('cancel.back')}
          </Link>
          <Link
            to={`/${i18n.language}`}
            className="inline-block border-2 border-primary text-primary font-bold uppercase tracking-widest px-12 py-5 text-lg hover:bg-primary hover:text-white transition-all duration-300"
          >
            {t('success.back')}
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default CancelPage;